import { render } from "./ColumnBarChartComponent.vue?vue&type=template&id=e2ec6c74"
import script from "./ColumnBarChartComponent.vue?vue&type=script&lang=js"
export * from "./ColumnBarChartComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__